import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const FormsScriptBetaAlert = () => /*#__PURE__*/_jsx(UIAlert, {
  type: "warning",
  titleText: I18n.text('editor.scriptBetaAlert.title'),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "editor.scriptBetaAlert.description"
  })
});
export default FormsScriptBetaAlert;